import { InjectionToken } from '@angular/core';
import { PumbFileParserService } from './pumb-file-parser.service';

export const PUMB_PARSER = new InjectionToken<PumbFileParserService>('PumbParser');
